import { endpoints } from "constant";

export const photoUrlBuilder = {
  savePhoto: function (): string {
    return endpoints.photos;
  },
};
